export enum alertEventDetailsTypes {
  eventDetails = "eventDetails",
  aiAssistant = "aiAssistant",
}
